import React from 'react';
import PropTypes from 'prop-types';

const ParticipantNameButton = ({ participantName, }) => {
  return (
    <button
      type="button"
      className="btn p-0 btn-link text-decoration-none"
      title="Click to view details"
    >
      {participantName}
    </button>
  );
};

ParticipantNameButton.propTypes = {
  participantName: PropTypes.string.isRequired,
};

export default ParticipantNameButton; 